import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterInvoicesValue,
  UniversalFilterInvoicesModes,
  UniversalFilterInvoicesFilterOptions,
  UniversalFilterInvoicesOnChange
} from './UniversalFilterInvoices.types';

import { useUniversalFilterInvoices } from './hooks/useUniversalFilterInvoices';

import { InvoicesMultiSelect } from '../../../../../main/invoices/helpers/InvoicesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterInvoicesProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterInvoicesValue;
  i18nName: I18nText;
  options?: UniversalFilterInvoicesFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterInvoicesOnChange;
}

function UniversalFilterInvoices({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterInvoicesProps) {
  const { modeOptions, filterState, handleModeChange, handleUserIdsChange } =
    useUniversalFilterInvoices({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterInvoicesModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterInvoicesModes.CONTAINS_ALL_OF
          // UniversalFilterInvoicesModes.DOES_NOT_CONTAIN_ANY_OF
        ],
        filterState.mode
      ) ? (
        <InvoicesMultiSelect
          value={filterState.invoiceIds || []}
          initialFilters={options?.initialInvoicesFilters}
          autoFocus={autoFocus}
          inputWrapperClassName="block"
          onChange={handleUserIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterInvoices;
